import { capitalize } from '@cc-shopping/utils/string/capitalize';
import type { MarketplaceEntity } from '../types';
import type { MarketplaceDriverConfig } from './types';

const ficoMap = {
  poor: {
    min: 300,
    max: 629,
  },
  average: {
    min: 630,
    max: 689,
  },
  good: {
    min: 690,
    max: 719,
  },
  excellent: {
    min: 720,
    max: 850,
  },
};

const BucketName = {
  user: 'user',
  poor: 'poor',
  average: 'average',
  good: 'good',
  excellent: 'excellent',
};

const getBucketFromScore = (score: number) => {
  if (score >= ficoMap.excellent.min) {
    return BucketName.excellent;
  }
  if (score >= ficoMap.good.min) {
    return BucketName.good;
  }
  if (score >= ficoMap.average.min) {
    return BucketName.average;
  }

  return BucketName.poor;
};

const getRecommendedCreditScoreFormattedDetails = (
  minCreditScoreIndex: number,
  maxCreditScoreIndex: number,
) => {
  const maxCreditScoreRange = capitalize(getBucketFromScore(maxCreditScoreIndex));
  const minCreditScoreRange = capitalize(getBucketFromScore(minCreditScoreIndex));
  const creditScoreRange =
    minCreditScoreIndex === maxCreditScoreIndex
      ? minCreditScoreIndex.toString()
      : `${minCreditScoreIndex}-${maxCreditScoreIndex}`;
  const creditScoreRangeDescription =
    maxCreditScoreRange === minCreditScoreRange
      ? minCreditScoreRange
      : `${minCreditScoreRange} - ${maxCreditScoreRange}`;

  return { creditScoreRange, creditScoreRangeDescription };
};

export const getDriverRecommendedCreditScoreRange = (
  offer: MarketplaceEntity,
): MarketplaceDriverConfig | null => {
  const minCreditScoreIndex = offer.minFico;
  const maxCreditScoreIndex = offer.maxFico;
  if (!(minCreditScoreIndex && maxCreditScoreIndex)) {
    return null;
  }

  const { creditScoreRange, creditScoreRangeDescription } =
    getRecommendedCreditScoreFormattedDetails(minCreditScoreIndex, maxCreditScoreIndex);

  return {
    id: 'recommendedCreditScoreRange',
    label: 'Rec credit score',
    value: creditScoreRange,
    description: creditScoreRangeDescription,
    labelTooltip: undefined,
    valueTooltip: undefined,
    valueTooltipHasHtml: false,
  };
};
